import graphql__538542f018f8fd8d5b59 from "./__generated__/AnalyticsDatumText_analyticsDatum.graphql.js";import { createFragmentContainer } from "react-relay";
import { graphql } from "react-relay";

import classNames from "classnames";
import Icon from "../Utils/Icon";

const AnalyticsDatumText = props => {
  const { label, count, iconClass } = props.analyticsDatum;
  const iconClassName =
    iconClass &&
    classNames(["text-primary", "text-metric", "margin-right-xxs", iconClass]);

  const countClassName = classNames([
    "margin-right-xxs",
    "font-weight-bold",
    { "text-primary": !iconClass }
  ]);

  return (
    <div className="analytics-datum-text d-flex flex-row align-items-center text-metric">
      {iconClass && <Icon className={iconClassName} />}
      <div className={countClassName}>{count}</div>
      <div className="flex-1 font-weight-normal">{label}</div>
    </div>
  );
};

export default createFragmentContainer(AnalyticsDatumText, {
  analyticsDatum: graphql__538542f018f8fd8d5b59
});
